"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconCompanyBuildingOutline = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M13 3 13 7 24 7 24 21 0 21 0 3 13 3ZM11 5 2 5 2 19 11 19 11 5ZM22 9 13 9 13 19 22 19 22 9ZM5.5 15 5.5 17 3.5 17 3.5 15 5.5 15ZM9.5 15 9.5 17 7.5 17 7.5 15 9.5 15ZM16.5 15 16.5 17 14.5 17 14.5 15 16.5 15ZM20.5 15 20.5 17 18.5 17 18.5 15 20.5 15ZM16.5 11 16.5 13 14.5 13 14.5 11 16.5 11ZM5.5 11 5.5 13 3.5 13 3.5 11 5.5 11ZM9.5 11 9.5 13 7.5 13 7.5 11 9.5 11ZM20.5 11 20.5 13 18.5 13 18.5 11 20.5 11ZM5.5 7 5.5 9 3.5 9 3.5 7 5.5 7ZM9.5 7 9.5 9 7.5 9 7.5 7 9.5 7Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconCompanyBuildingOutline')(IconCompanyBuildingOutline);